module.exports = __webpack_public_path__ + "static/media/banner.c4a4755e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/banner.jpg
// module id = 182
// module chunks = 0